import React from 'react';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';

const HeroSection = () => {
  const navigate = useNavigate();
  const { currentLanguage, t } = useLanguage();

  // Mobile-optimized translations (max 60-70 chars for descriptions on 320px)
  const content = {
    en: {
      title: "Reliable Taxi Service Across Phangan Island",
      subtitle: "",
      description: "Fast, safe, comfortable. Available 24/7. Book in seconds.",
      cta: "Book Your Ride Now"
    },
    uk: {
      title: "Надійне Таксі на Ко Пангані",
      subtitle: "",
      description: "Швидко, безпечно, комфортно. Доступно 24/7. Бронюйте за секунди.",
      cta: "Замовити Таксі"
    },
    ru: {
      title: "Надежное Такси на Ко Пангане",
      subtitle: "",
      description: "Быстро, безопасно, комфортно. Доступно 24/7. Бронируйте за секунды.",
      cta: "Забронировать"
    },
    th: {
      title: "บริการแท็กซี่ที่เชื่อถือได้",
      subtitle: "ทั่วเกาะพะงัน",
      description: "รวดเร็ว ปลอดภัย สะดวกสบาย บริการ 24/7 จองได้ทันที",
      cta: "จองเลย"
    },
    de: {
      title: "Zuverlässiger Taxiservice",
      subtitle: "Auf Koh Phangan",
      description: "Schnell, sicher, komfortabel. 24/7 verfügbar. In Sekunden buchen.",
      cta: "Jetzt Buchen"
    },
    fr: {
      title: "Service de Taxi Fiable",
      subtitle: "À Koh Phangan",
      description: "Rapide, sûr, confortable. Disponible 24/7. Réservez en secondes.",
      cta: "Réserver"
    },
    zh: {
      title: "可靠的出租车服务",
      subtitle: "帕岸岛全岛",
      description: "快速、安全、舒适。24/7可用。几秒预订。",
      cta: "立即预订"
    },
    es: {
      title: "Servicio de Taxi Confiable",
      subtitle: "En Koh Phangan",
      description: "Rápido, seguro, cómodo. Disponible 24/7. Reserve en segundos.",
      cta: "Reservar"
    },
    it: {
      title: "Taxi Affidabile",
      subtitle: "A Koh Phangan",
      description: "Veloce, sicuro, confortevole. Disponibile 24/7. Prenota in secondi.",
      cta: "Prenota Ora"
    },
    nl: {
      title: "Betrouwbare Taxidienst",
      subtitle: "Op Koh Phangan",
      description: "Snel, veilig, comfortabel. 24/7 beschikbaar. Boek in seconden.",
      cta: "Boek Nu"
    },
    he: {
      title: "שירות מוניות אמין",
      subtitle: "ברחבי קוה פנגן",
      description: "מהיר, בטוח, נוח. זמין 24/7. הזמן בשניות.",
      cta: "הזמן עכשיו"
    }
  };

  const currentContent = content?.[currentLanguage] || content?.en;

  return (
    <div className="relative min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60 z-10" />
      <div className="relative z-20 max-w-4xl mx-auto text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 leading-tight">
          {currentContent?.title}
        </h1>
        {currentContent?.subtitle && (
          <p className="text-2xl sm:text-3xl md:text-4xl text-accent font-semibold mb-6">
            {currentContent?.subtitle}
          </p>
        )}
        <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-12 max-w-2xl mx-auto leading-relaxed">
          {currentContent?.description}
        </p>
        
        <Button
          variant="default"
          size="xl"
          onClick={() => navigate('/smart-booking-form')}
          iconName="Calendar"
          iconPosition="left"
          className="bg-accent hover:bg-accent/90 text-accent-foreground font-semibold px-12 py-6 text-lg sm:text-xl shadow-2xl transform hover:scale-105 transition-all duration-200"
        >
          {currentContent?.cta}
        </Button>
      </div>
    </div>
  );
};

export default HeroSection;